const menuData = [
  {
    name: '学院首页',
    icon: '',
    path: 'home',
  },
  {
    name: '藏经阁',
    icon: '',
    path: 'collection',
    children: [
      {
        name: '藏经阁详情',
        path: 'detail',
      },
    ],
  },
  {
    name: '专题栏',
    icon: '',
    path: 'topics',
    children: [],
  },
  {
    name: '进阶课程',
    icon: '',
    path: 'levelup',
    children: [],
  },
  {
    name: '课件库',
    icon: '',
    path: 'courseware',
    children: [],
  },
]

export default menuData
